<div class="excel-download" [ngClass]="{ 'excel-ar-download': current_lang === 'ar' }">
    <!--- Download icon -->
    <div class="download-excel-outer" *ngIf="
      tableData?.length !== 0 &&
      tableData
    ">
        <button class="download_excel" [disabled]="LockReport" *ngIf="!downloadLoading" (click)="downloadExcel()"
            matTooltip="{{ 'reports.download_excel' | translate }}" matTooltipPosition="above"><img *ngIf="!LockReport"
                src="../../../../../../assets/images/excel-icon.svg" />
            <img *ngIf="LockReport" src="../../../../../../assets/images/excel-icon-disable.svg" /></button>
        <span *ngIf="downloadLoading"><mat-spinner class="download-spinner"></mat-spinner></span>
    </div>
</div>

<div class="main-table">
    <table class="table normal-table" matSort (matSortChange)="onSortTable($event)">
        <thead>
            <tr>
                <th *ngFor="let tableColumn of tableColumns" mat-sort-header="{{ tableColumn.header }}">
                    <span class="header_label">
                        {{ tableColumn?.columnName | translate }}
                        <span class="text-transform-normal">{{ tableColumn?.symbol |
                            reportDataValueType }}</span>
                    </span>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let element of tableData; let i = index"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                (click)="setExpadndColor(i)" [@detailExpand]="element.isOpen === 1 ? 'collapsed' : 'expanded'"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                [ngClass]="(expandedElement === element && !element['outlier'] ? 'example-expanded-row':'')"
                [ngClass]="{ hideTable: !showLoader }"
                [class.expand-hide]="element.isOpen === 1" [ngClass]="{'blur-content': element['NODATA']}">
                <td>
                    <div class="column-data align-items-center position-relative">
                        <div class="tooltip showonmap-column">
                            <!-- Column Name Text -->
                            <span class="column_entry" [attr.title]="element?.property_name"
                                (click)="panToMap(element, tableColumns[0].field, i, 'showOnMap', true, element?.is_layout)"
                                [ngClass]="{'link_item': (element?.lat && tableColumns[0]?.showOnMap && tableColumns[0]?.isAnchor)}">
                                {{element?.property_name }}
                            </span>
                            <span *ngIf="element?.estater_tracked == 'true'" class="estater-tracked">*</span>
                        </div>
                        <span class="show_on_map"
                            [ngClass]="{'clicked_item': selectedIndex === ('' + goToPageNumber + i)}"
                            (click)="panToMap(element, tableColumns[0].field, i, 'showOnMap')"
                            matTooltip="{{'reports.show_on_map' | translate}}">
                            <mat-icon svgIcon="location" class="icon" *ngIf="!element?.is_layout"></mat-icon>
                            <mat-icon svgIcon="floorLayoutIcon" class="icon" *ngIf="element?.is_layout"></mat-icon>
                        </span>
                        <!-- Show On Map Loader -->
                        <span class="tenent_map_icon loader__"
                            *ngIf="(element?.lat || element?.tenants_lat_lon) && selectedIndex === ('' + goToPageNumber + i) && tenantLoading"
                            [ngClass]="{'clicked_item': tenantLoading && selectedIndex === ('' + goToPageNumber + i)}"><mat-spinner
                                class="download-spinner"></mat-spinner></span>
                    </div>
                </td>
                <td>{{element?.type || '-'}}</td>
                <td>{{element?.property_grade || '-'}}</td>
                <td>{{element?.office_space ? (element?.office_space | number: '1.0-1') : '-'}}</td>
                <td>{{element?.retail_space ? (element?.retail_space | number: '1.0-1') : '-'}}</td>
                <td>{{element?.average_office_lease_rate ? (element?.average_office_lease_rate | number: '1.0-1') : '-'}}</td>
                <td>{{element?.average_retail_lease_rate ? (element?.average_retail_lease_rate | number: '1.0-1') : '-'}}</td>
                <td>{{element?.land_area ? (element?.land_area | number: '1.0-1') : '-'}}</td>
                <td>{{element?.year_of_built || '-'}}</td>
            </tr>
            <tr *ngIf="!showLoader" style="height: auto;" class="loader-tr">
                <td style="padding: 0;" [attr.colspan]="tableColumns?.length">
                    <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
    <!--- No Record Found -->
    <div class="data_unavail" *ngIf="(tableData?.length === 0 || !tableData) && showLoader">
        <span>
            {{"reports.dataComingSoon" | translate}}
        </span>
    </div>
    <!-- Table content blur start -->
    <div class="lock-table-row" *ngIf="LockReport">
        <img src="../../../../../../assets/images/Lock.png" alt="">
    </div>
</div>
<!--- Pagination -->
<div class="pagination-wrapper pagination-showing-count"
    *ngIf="tableData?.length !== 0 && tableData && !hidePagination">
    <ng-container *ngIf="show_step_count">
        <p *ngIf="!LockReport" [class.showingrecord-margin]="dataLength > 2">
            {{ "reports.Showing" | translate }} {{ startIndex }}
            {{ "reports.to" | translate }} {{ endIndex }}
            {{ "reports.outOf" | translate }}
            {{ dataLength | internationalNumber }}
            {{ "reports.records" | translate}}
        </p>
    </ng-container>
    <p *ngIf="LockReport" class="pb-2">
        <span class="contact-sale" (click)="openContactSales()">{{'contactSales' | translate }}</span>
        {{'to_unlock' | translate }} <ng-container *ngIf="dataLength > 3"> {{(dataLength
            - 3) | internationalNumber }} {{'rows_more'| translate}}</ng-container> <ng-container
            *ngIf="dataLength <= 3">{{'more_rows'|
            translate}}</ng-container>.
    </p>

    <mat-paginator *ngIf="dataLength > 20" [disabled]="!showLoader || LockReport" class="default-pagination"
        [length]="dataLength" [pageSize]="20" [pageSizeOptions]="[5, 10, 15, 25, 100]" [showFirstLastButtons]="true"
        (page)="onPageChange($event)" [hidePageSize]="true">
    </mat-paginator>

    <!-- Pagination input -->
    <div class="go-to-page d-flex align-items-center" *ngIf="dataLength > 20">
        <input class="go-to-page-input" type="number" [(ngModel)]="goToPageNumber" (change)="onGoToPage()"
            [disabled]="totalPages === 1 || !showLoader || LockReport" />
        <span class="oftext">of</span>
        <span>{{ totalPages }}</span>
    </div>
</div>

<!--- data cleaned Text -->
<div class="dataCleaned">
  <span *ngIf="showEstaterText"> {{ "reports.dataCleaned" | translate }}
  </span>
  <span *ngIf="tableData?.length > 0">* {{'reports.Estater_Tracked_Properties' | translate}}</span>
</div>
